<template>
  <v-card>
    <v-card-text>
      <v-form ref="ProductForm" v-model="ProductValid">
        <v-row>
          <v-col cols="12" sm="6" md="6" v-if="!isSelectedProduct">
            <!-- :disabled="!editProductTitleSuggestion"     "EditProdNoBase" or "EditProdByBase" -->
            <v-text-field
              dense
              label=" نام *"
              required
              :rules="[(v) => !!v || 'وارد کردن نام الزامی میباشد']"
              v-model="product.name"
              class="mt-1"
              outlined
              :disabled="
                createActionName == 'NewProdByBase' ||
                editActionName == 'EditProdByBase'
              "
            ></v-text-field>
          </v-col>
      
          <v-col
            cols="12"
            md="4"
            sm="6"
            v-if="
              !(
                createActionName == 'NewProdByBase' ||
                editActionName == 'EditProdByBase'
              )
            "
          >
            <v-checkbox
              v-model="editProductTitleSuggestion"
              label="عنوان پیشنهادی نیاز به اصلاح دارد"
              small
              dense
            ></v-checkbox>
          </v-col>
      
     
               <v-col cols="12" sm="6" md="3" v-if="selesctedCategory?.measurementQuantityId">
           
              <v-select
              dense
              :items="selesctedCategory.units"
              v-model="product.measurementUnitId"
              label="واحد فروش جهت اعلام قیمت"
              item-text="displayText"
              item-value="id"
              class="mt-2"
              outlined
                 :disabled="
                createActionName == 'NewProdByBase' ||
                editActionName == 'EditProdByBase'
              "
            ></v-select>
          </v-col>
            <v-col cols="12" sm="6" md="3" v-if="!isSelectedProduct">
             <v-text-field
              dense
              label=" حداقل مقدار فروش(عرضه کالا/خدمت) *"
              required
              :rules="[(v) => !!v  || 'وارد کردن این فیلد الزامی میباشد']"
              v-model="product.minimumOrderVolume"
              class="mt-1"
              outlined
              type="number"
              
            ></v-text-field>
          </v-col>
           <v-col cols="12" sm="6" md="6">
            <v-combobox
              v-model="product.tags"
              required
              :rules="[
                (v) =>
                  v?.length > 0 || 'وارد کردن حداقل یک برچسب الزامی می‌باشد',
              ]"
              hide-selected
              label="برچسب‌ها"
              multiple
              persistent-hint
              small-chips
              outlined
              dense
              clearable
              class="mt-1"
              :disabled="
                createActionName == 'NewProdByBase' ||
                editActionName == 'EditProdByBase'
              "
            >
            </v-combobox>
          </v-col>
          <v-col cols="12"  > 
            <v-text-field
              dense
              label="خلاصه خدمت/کالا*"
              required
              :rules="[
                (v) => !!v || 'وارد کردن خلاصه الزامی میباشد',
                (v) =>
                  (v && v.length <= 200 && v.length >= 100) ||
                  'خلاصه خدمت/کالا حداقل ۱۰۰ و حداکثر ۲۰۰ کاراکتر باید باشد طول وارد شده :' +
                    'کاراکتر ' +
                    v.length,
              ]"
              v-model="product.summary"
              class="mt-1"
              outlined
              :disabled="
                createActionName == 'NewProdByBase' ||
                editActionName == 'EditProdByBase'
              "
            ></v-text-field>
          </v-col>
      
         
          <v-col cols="12">
            <label for=""> شرح خدمت/محصول/کالا *</label>
            <!-- v-if="isEditableStep3And4Fields" -->
            <html-editor
              v-if="
                !(
                  createActionName == 'NewProdByBase' ||
                  editActionName == 'EditProdByBase'
                )
              "
              v-model="product.description"
              :htmlValue="product.description"
              @htmlChange="(a) => (product.description = a)"
            ></html-editor>
            <div class="border p-3" v-else v-html="product.description"></div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer> </v-spacer>
      <v-btn @click="beforeStep()" color="secondery">
          بازگشت به مرحله قبل
      </v-btn>
      <v-btn @click="nextStep()" color="primary">  مرحله بعد </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import HtmlEditor from '@/components/core/CKEditor';
export default {
  components: { HtmlEditor },
  props: {
    isSelectedProduct: {
      default: false,
      type: Boolean,
    },
    selectedProduct: {
      default: null,
      type: Object,
    },
    categoryType: {
      type: String,
      default: null,
    },
    productTitleSuggestion: {
      type: String,
      default: null,
    },
    categoryTypeDisplayName: {
      type: String,
      default: null,
    },
    forEdit: {
      type: Boolean,
      default: null,
    },
    editActionName: {
      type: String,
      default: 'unknown',
    },
    createActionName: {
      type: String,
      default: 'unknown',
    },
    selesctedCategory: {
           default: null,
      type: Object,
    }
    //   :editActionName="editActionName"
    // :createActionName="createActionName"
  },
  data() {
    return {
      ProductValid: true,
      product: {
        name: null,
        description: '',
        summary: null,
        taxed: false,
        tags: [],
        properties: [],
        productProperties: [],
        measurementUnitId: null,
        measurementUnitDisplayText: '',
        measurementUnitProperName: '',
        measurementQuantityId: null,
        measurementQuantityDisplayText: '',
        measurementQuantityProperName: '',
        units: [],
        minimumOrderVolume:1,
      },
      editProductTitleSuggestion: false,
    };
  },
  created() {
    //  console.log("selectedProduct in creted func")
    // console.log(this.$store.getters.supplierProductSelectedForEdit)
    // console.log("forEdit")
    //  console.log(this.forEdit)
    if (this.forEdit) {
      this.product.description =
        this.$store.getters.supplierProductSelectedForEdit.description;
      this.product.summary =
        this.$store.getters.supplierProductSelectedForEdit.summary;
      this.product.taxed =
        this.$store.getters.supplierProductSelectedForEdit.taxed;
      this.product.name =
        this.$store.getters.supplierProductSelectedForEdit.name;
      this.product.tags =
        this.$store.getters.supplierProductSelectedForEdit.tags;
      //--------------start
      this.product.measurementUnitId =
        this.$store.getters.supplierProductSelectedForEdit.measurementUnitId;
      this.product.measurementUnitDisplayText =
        this.$store.getters.supplierProductSelectedForEdit.measurementUnitDisplayText;
      this.product.measurementUnitProperName =
        this.$store.getters.supplierProductSelectedForEdit.measurementUnitProperName;
      this.product.measurementQuantityId =
        this.$store.getters.supplierProductSelectedForEdit.measurementQuantityId;
      this.product.measurementQuantityDisplayText =
        this.$store.getters.supplierProductSelectedForEdit.measurementQuantityDisplayText;
      this.product.measurementQuantityProperName =
        this.$store.getters.supplierProductSelectedForEdit.measurementQuantityProperName;
      this.product.units =
        this.$store.getters.supplierProductSelectedForEdit.units;
      this.product.minimumOrderVolume =
        this.$store.getters.supplierProductSelectedForEdit.minimumOrderVolume;
        

      //---------End
    }
  },
  watch: {
    isSelectedProduct(after, before) {
      if (after) {
        this.fillValueInput(this.selectedProduct);
      } else if (!after & !this.forEdit) {
        this.product = {
          name: this.productTitleSuggestion,
          description: '',
          summary: null,
          taxed: false,
          tags: [],
        };
      }
    },
    productTitleSuggestion(after, before) {
      if (after) {
        this.product.name = this.productTitleSuggestion;
      }
    },
    selectedProduct(after, before) {
      // console.log('selectedProduct in creted func');
      // console.log(this.selectedProduct);
      if (before.name == null && after.name != null) {
        if (this.$store.getters.supplierProductSelectedForEdit) {
          this.product.description =
            this.$store.getters.supplierProductSelectedForEdit.description;
          this.product.summary =
            this.$store.getters.supplierProductSelectedForEdit.summary;
          this.product.taxed =
            this.$store.getters.supplierProductSelectedForEdit.taxed;
          this.product.name =
            this.$store.getters.supplierProductSelectedForEdit.name;
          this.product.tags =
            this.$store.getters.supplierProductSelectedForEdit.tags;

          // this.product.properties = after.properties;
          // this.product.productProperties = after.productProperties;
        }
      }
    },
  },
  methods: {
    beforeStep() {
      this.$emit('goToPropertyStep');
    },
    nextStep() {
      //alert("nextStep")
      //   alert(this.product.properties.length)
      if (this.$refs.ProductForm.validate() && this.product.description) {
        if (!this.isSelectedProduct) {
          //this.product.tags.length > 0 => فیلد تگز وجود ندارد فعلاً ازش عبور میکنیم تا بعد
          if (this.product.tags?.length > 0) {
            this.$emit('completeProductDetailData', this.product);
          } else {
            this.$dialog.error({
              text: 'وارد کردن موارد ستاره دار الزامی میباشد',
              title: 'خطا',
              persistent: true,
              actions: [
                {
                  text: 'بستن',
                  color: 'red',
                },
              ],
            });
          }
        } else {
          this.$emit('completeProductDetailData', this.product);
        }
      } else {
        this.$emit('completeProductDetailData', this.product);
        //   this.$dialog.error({
        //     text: 'وارد کردن موارد ستاره دار الزامی میباشد',
        //     title: 'خطا',
        //     persistent: true,
        //     actions: [
        //       {
        //         text: 'بستن',
        //         color: 'red',
        //       },
        //     ],
        //   });
      }
    },
    fillValueInput(data) {
      console.log("data in fillValueInput", data)
      if (data) {
        this.product.name = data.name;
        this.product.description = data.description;
        this.product.summary = data.summary;
        this.product.taxed = data.taxed;
        this.product.tags = data.tags;
        this.product.measurementUnitId = data.measurementUnitId;
      }
    },
  },
  computed: {
    //فیلدهای توضیحات، خلاصه، تگ و تصاویر مد نظر هست
    isEditableStep3And4Fields() {
      let iseditAble = false;
      //اگر محصول انتخاب شده برای ایجاد از روی محصولات   پایه انتتخاب شده
      //اگر ویرایش می‌شود شرایط اینکه آیا از ابتدا توسط همین مرچنت ایجاد شده
      //یا از روی محصولات پایه
      //اگر خودش ایجاد کرده ایا هنوز کس دیگری از این محصول پایه استفاده می‌کند؟
      if (this.isSelectedProduct == false) {
        return true;
      } // به معنی ایجاد محصول جدید از ابتدا در حال انجام هست
      if (this.isSelectedProduct && this.foredit) {
        //محصول مد نظر بررسی می‌شود
        if (this.selectedProduct.productCreatedByThisMerchant) {
          return true;
        } else {
          return false;
        }
        //this.selectedProduct.productAdminConfirmed
        //this.selectedProduct.productCreatedByThisMerchant
        //this.selectedProduct.supplierProductStatus
      }
      if (this.isSelectedProduct && this.foredit == false) {
        //یعنی حالت ایجاد محصول از روی محصولات پایه

        //فیلدهای محصول انتخاب شده وقتی از روی یک محص.ل پایه انجام می‌شود با حالت ویرتیش اندکی تفاوت دارد
        //مثل این فیلد adminConfirmed
        //که در حالت ویرایش دارای نام
        //productAdminConfirmed
        //هست اینجا دقت شود
        if (this.selectedProduct.adminConfirmed) {
          return false;
        } else {
          return true;
        }
      }
      return iseditAble;
    },
  },
};
</script>

<style></style>
